import type { DesignListItem } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { quoteRequestPath, storeCustomizeDesignPath } from '@/shared/config';
import { buttonVariants, cn } from '@/shared/ui';

interface MyDesignActionsProps {
  readonly design: DesignListItem;
}

/** 각진 버튼 — 밑줄·흑연 언어에 맞춰 둥근 알약 대신 모서리를 세운다. */
const ACTION_CLASS = 'h-10 flex-1 rounded-none px-3 text-[13px] font-semibold tracking-[-0.01em]';

/**
 * 디자인 카드 버튼 줄 — 수정(커스터마이징 ?designId=, 같은 디자인 덮어쓰기)·견적 요청(/request/:designId).
 * 복제·삭제는 이름 줄의 아이콘(MyDesignTools)이다. 판매 중이 아닌 상품(숨김·초안)은 서버가 열기를 막으므로 안내만 남긴다.
 */
export const MyDesignActions = ({ design }: MyDesignActionsProps): ReactElement => {
  if (design.productStatus !== 'PUBLISHED') {
    return <p className="text-xs text-muted-foreground">판매가 중지된 상품의 디자인입니다.</p>;
  }

  return (
    <div className="flex gap-2">
      <Link
        to={storeCustomizeDesignPath(design.productId, design.id)}
        aria-label={`${design.name} 수정`}
        className={cn(
          buttonVariants({ variant: 'outline' }),
          ACTION_CLASS,
          'border-foreground/25 hover:border-foreground hover:bg-background',
        )}
      >
        수정
      </Link>
      <Link
        to={quoteRequestPath(design.id)}
        aria-label={`${design.name} 견적 요청`}
        className={cn(buttonVariants(), ACTION_CLASS)}
      >
        견적 요청
      </Link>
    </div>
  );
};
